import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "../lib/api";

const About = () => {
  const [frontendVersion, setFrontendVersion] = useState<string>("");
  const [backendVersion, setBackendVersion] = useState<string>("");

  useEffect(() => {
    // Carrega versão do frontend
    fetch("/version.json")
      .then((res) => {
        console.log("Frontend version response:", res);
        return res.json();
      })
      .then((data) => {
        console.log("Frontend version data:", data);
        setFrontendVersion(data.version || "");
      })
      .catch((error) => {
        console.error("Erro ao carregar versão do frontend:", error);
        setFrontendVersion("Erro");
      });

    // Carrega versão do backend usando a API configurada
    api
      .get("/version")
      .then((res) => {
        console.log("Backend version response:", res);
        setBackendVersion(res.data.version || "");
      })
      .catch((error) => {
        console.error("Erro ao carregar versão do backend:", error);
        setBackendVersion("Erro");
      });
  }, []);

  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-4">Sobre o SDR System</h1>
      <p className="mb-6 text-lg text-muted-foreground">
        O <strong>SDR System</strong> é uma plataforma moderna para gestão de
        campanhas, leads e atendimento ao cliente, desenvolvida para facilitar o
        dia a dia de equipes comerciais e de marketing.
      </p>
      <ul className="mb-6 list-disc list-inside space-y-2">
        <li>
          Chat com atualização em tempo real para conversas ágeis e eficientes.
        </li>
        <li>Gestão centralizada de campanhas e leads.</li>
        <li>Relatórios e dashboards para acompanhamento de resultados.</li>
        <li>Ambiente seguro e multiempresa.</li>
      </ul>
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Suporte e contato</h2>
        <p className="mb-1">Precisa de ajuda, tem dúvidas ou sugestões?</p>
        <div className="flex items-center gap-2">
          <Mail className="w-5 h-5 text-primary" />
          <a href="mailto:ia@grupos2mkt.com" className="underline text-primary">
            ia@grupos2mkt.com
          </a>
        </div>
      </div>
      <div className="text-sm text-muted-foreground mt-6">
        <div>Versão do Frontend: {frontendVersion || "Carregando..."}</div>
        <div>Versão do Backend: {backendVersion || "Carregando..."}</div>
      </div>
    </div>
  );
};

export default About;
